import React, { FC } from 'react'
import { Button, Modal } from '@wmgtech/legato'
import useDeleteArtist from 'modules/Artists/serviceHooks/useDeleteArtist'
import { ArtistEditActionProps } from './ArtistEditAction.props'

const ArtistEditAction: FC<ArtistEditActionProps> = ({ id, artist, products }) => {
  const { onDeleteArtist, isModalOpened, onCloseModal, onConfirmDelete } = useDeleteArtist({ id, artist, products })

  return (
    <>
      <Button
        containerStyle="outline"
        colorType="danger"
        label={'Delete Artist'}
        secondaryIcon="trash-can"
        onClick={onDeleteArtist}
      />
      <Button
        containerStyle="solid"
        colorType="secondary-black"
        label={'Save'}
        form="artist-form"
        htmlType="submit"
      />
      <Modal
        size="sm"
        isOpen={isModalOpened}
        onClose={onCloseModal}
        title="Delete Artist"
        footer={
          <div className="artist-form__modal--footer">
            <Button colorType="secondary-black" containerStyle="outline" onClick={onCloseModal}>
              Cancel
            </Button>
            <Button colorType="secondary-black" onClick={onConfirmDelete}>
              Okay
            </Button>
          </div>
        }
      >
        <p>
          Permanently delete <b>{artist?.name}</b>?
        </p>
      </Modal>
    </>
  )
}

export default ArtistEditAction
